import ProjectWorkerTableItem from "@/viewmodels/project-worker-table-item";
import TaskType from "@/entities/task-type";
import { StaffId } from "@/entities/ids";

export default function ProjectWorkerTableItemDecorator(
  worker: ProjectWorker
): ProjectWorkerTableItem {
  return {
    id: worker.id,
    name: worker.name,
    tel: worker.tel,
    email: worker.email,
    worktype: worker.workTypes.map(t => t.name).join(", "),
    inviteStatus: worker.inviteStatus,
    isHiddenInfo: worker.isHiddenInfo,
    hasInviteButton: hasInviteButton(worker.inviteStatus)
  };
}

function hasInviteButton(status: string): boolean {
  return status === "未招待" || status === "未承認";
}

interface ProjectWorker {
  id: StaffId;
  name: string;
  tel: string;
  email: string;
  workTypes: TaskType[];
  inviteStatus: string;
  isHiddenInfo: number;
}
